//let API_URL='api.5050.vct.xyz'
let API_URL='api-5050.maximevincent.fr/api'

export default {
    API_URL,
}
